<script lang="ts">
  import clsx from 'clsx'
  import componentAttributesStore from '../../stores/componentAttributes.svelte'
  import CloseIcon from './icons/CloseIcon.svelte'
  import { THEMES } from '../../const/themes'
  import type { Snippet } from 'svelte'

  type Props = {
    onclose: () => void
    children: Snippet
  }

  let { onclose, children }: Props = $props()
</script>

<div
  style={`color: ${componentAttributesStore.state.overlayTextColor || THEMES.DEFAULT.OVERLAY_TEXT_COLOR};`}
  class={clsx(
    'absolute bottom-0 left-0 w-full h-full backdrop-blur-sm pt-[2%] pr-[10%] pb-[5%] pl-[5%]',
  )}
>
  <div
    class="absolute top-0 left-0 w-full h-full opacity-80"
    style={`background-image: linear-gradient(to bottom, ${componentAttributesStore.state.overlayBackgroundTopColor || THEMES.DEFAULT.OVERLAY_BACKGROUND_TOP_COLOR}, ${componentAttributesStore.state.overlayBackgroundBottomColor || THEMES.DEFAULT.OVERLAY_BACKGROUND_BOTTOM_COLOR});`}
  ></div>

  <div
    class={clsx(
      'scrollbar-thin  scrollbar-thumb-rounded-full scrollbar-track-rounded-full  scrollbar-thumb-slate-500/70 scrollbar-track-slate-800/40',
      'absolute bottom-0 left-0 w-full h-full pt-[2%] pr-[10%] pb-[5%] pl-[5%]  overflow-y-auto',
    )}
  >
    <div class="flex flex-col justify-center min-h-full">
      {@render children()}
    </div>
  </div>
  <button
    class="absolute top-0 right-0 mt-3 mr-4 h-7 w-7"
    style="stroke: {componentAttributesStore.state.buttonsColor ||
      THEMES.DEFAULT.BUTTONS_COLOR};"
    onclick={() => onclose()}
  >
    <CloseIcon />
  </button>
</div>
